import React, { createContext, useState, useContext } from 'react';
import { en } from '../translations/en';
import { ro } from '../translations/ro';
import { getLanguagePreference, setLanguagePreference, hasFunctionalConsent } from '../utils/cookies';

const AppContext = createContext();

export const useApp = () => {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error('useApp must be used within AppProvider');
    }
    return context;
};

export const AppProvider = ({ children }) => {
    // Language State - Initialize from cookie only if consent given
    const [language, setLanguage] = useState(() => {
        // Check if user has functional consent
        const hasConsent = hasFunctionalConsent();
        if (hasConsent) {
            return getLanguagePreference();
        }
        // Default to Romanian if no consent
        return 'ro';
    });

    // Get translations based on current language
    const translations = language === 'en' ? en : ro;

    // Toggle Language
    const toggleLanguage = () => {
        const newLang = language === 'en' ? 'ro' : 'en';
        setLanguage(newLang);
        
        // Only save to cookie if user has given consent
        if (hasFunctionalConsent()) {
            setLanguagePreference(newLang);
        }
    };

    const value = {
        language,
        setLanguage,
        toggleLanguage,
        t: translations, // t for translations
    };

    return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
